import Dashboard from "../pages/admin/Dashboard";
import BookingsList from "../pages/admin/bookings/List";
import BookingDetails from "../pages/admin/bookings/Details";
import BookingCalendar from "../pages/admin/bookings/Calendar";
import RoomList from "../pages/admin/rooms/List";
import AddRoom from "../pages/admin/rooms/AddUpdate";
import ServiceList from "../pages/admin/services/List";
import AddService from "../pages/admin/services/AddUpdate";
import MembershipPlanList from "../pages/admin/membership_plans/List";
import AddMembershipPlan from "../pages/admin/membership_plans/AddUpdate";
import Subscribers from "../pages/admin/membership_plans/Subscribers";
import CancellationRequests from "../pages/admin/membership_plans/CancellationRequests";
import NotificationsList from "../pages/admin/notifications/List";
import BroadcastList from "../pages/admin/broadcasts/List";
import BroadcastCreate from "../pages/admin/broadcasts/AddUpdate";
import BroadcastDetails from "../pages/admin/broadcasts/Details";
import SystemUserList from "../pages/admin/system_users/List";
import AddSystemUser from "../pages/admin/system_users/AddUpdate";
import AttendanceList from "../pages/admin/attendance/List";
import RoleList from "../pages/admin/roles/List";
import AddRole from "../pages/admin/roles/AddUpdate";
import Account from "../pages/admin/Account";
import UserList from "../pages/admin/users/List";
import CustomerDetails from "../pages/admin/users/CustomerDetails";
import PageList from "../pages/admin/pages/List";
import AddPage from "../pages/admin/pages/AddUpdate";
import Setting from "../pages/admin/Setting";

const adminRoutes = [
  {
    path: "/admin/dashboard",
    component: Dashboard,
    meta: { requiresAuth: true, permission: "dashboard.view" },
  },

  // Bookings
  {
    path: "/admin/bookings",
    component: BookingsList,
    meta: { requiresAuth: true, permission: "bookings.index" },
  },
  {
    path: "/admin/booking-calendar",
    component: BookingCalendar,
    meta: { requiresAuth: true, permission: "bookings.calendar" },
  },
  {
    path: "/admin/bookings/:id",
    component: BookingDetails,
    meta: { requiresAuth: true, permission: "bookings.show" },
  },

  // Users
  {
    path: "/admin/users",
    component: UserList,
    meta: { requiresAuth: true, permission: "users.index" },
  },
  {
    path: "/admin/users/:id",
    component: CustomerDetails,
    meta: { requiresAuth: true, permission: "users.show" },
  },

  // Rooms
  {
    path: "/admin/rooms",
    component: RoomList,
    meta: { requiresAuth: true, permission: "rooms.index" },
  },
  {
    path: "/admin/rooms/create/:id?",
    component: AddRoom,
    meta: { requiresAuth: true, permission: "rooms.save" },
  },

  // Services
  {
    path: "/admin/services",
    component: ServiceList,
    meta: { requiresAuth: true, permission: "services.index" },
  },
  {
    path: "/admin/services/create/:id?",
    component: AddService,
    meta: { requiresAuth: true, permission: "services.save" },
  },

  // Membership plans
  {
    path: "/admin/membership-plans",
    component: MembershipPlanList,
    meta: { requiresAuth: true, permission: "membership-plans.index" },
  },
  {
    path: "/admin/membership-plans/create/:id?",
    component: AddMembershipPlan,
    meta: { requiresAuth: true, permission: "membership-plans.save" },
  },
  {
    path: "/admin/membership-plans/subscribers",
    component: Subscribers,
    meta: { requiresAuth: true, permission: "membership-plans.subscribers" },
  },
  {
    path: "/admin/membership-plans/cancellation-requests",
    component: CancellationRequests,
    meta: { requiresAuth: true, permission: "membership-plans.cancellation-requests" },
  },

  // Pages (CMS)
  {
    path: "/admin/pages",
    component: PageList,
    meta: { requiresAuth: true, permission: "pages.index" },
  },
  {
    path: "/admin/pages/create/:id?",
    component: AddPage,
    meta: { requiresAuth: true, permission: "pages.save" },
  },

  // Notifications — the admin's own inbox. No longer in the sidebar; reached
  // from the header bell, so the route has to stay.
  {
    path: "/admin/notifications",
    component: NotificationsList,
    meta: { requiresAuth: true, permission: "notifications.index" },
  },

  // Send Notifications (broadcasts to app users)
  {
    path: "/admin/broadcasts",
    component: BroadcastList,
    meta: { requiresAuth: true, permission: "broadcasts.index" },
  },
  {
    path: "/admin/broadcasts/create",
    component: BroadcastCreate,
    meta: { requiresAuth: true, permission: "broadcasts.save" },
  },
  {
    path: "/admin/broadcasts/:id",
    component: BroadcastDetails,
    meta: { requiresAuth: true, permission: "broadcasts.show" },
  },

  // Team Management
  {
    path: "/admin/system-users",
    component: SystemUserList,
    meta: { requiresAuth: true, permission: "system-users.index" },
  },
  {
    path: "/admin/system-users/create/:id?",
    component: AddSystemUser,
    meta: { requiresAuth: true, permission: "system-users.save" },
  },
  {
    path: "/admin/roles",
    component: RoleList,
    meta: { requiresAuth: true, permission: "roles.index" },
  },
  {
    path: "/admin/roles/create/:id?",
    component: AddRole,
    meta: { requiresAuth: true, permission: "roles.save" },
  },
  {
    path: "/admin/attendance",
    component: AttendanceList,
    meta: { requiresAuth: true, permission: "attendance.index" },
  },

  // System Configuration
  {
    path: "/admin/settings",
    component: Setting,
    meta: { requiresAuth: true, permission: "settings.view" },
  },

  // Account
  {
    path: "/admin/account",
    component: Account,
    meta: { requiresAuth: true, permission: "account.view" },
  },
];

export default adminRoutes;
